<template>
  <div id="reset-password">
    <div style="margin-top: 3%" class="row">
      <div class="col-md-3 custom-form">
        <div v-if="msg" class="alert alert-primary text-center">
          <p>{{$t('message.' + msg)}}</p>
          <button v-if="success" @click="goToPage('Main')" style="cursor: pointer;" class="btn btn-primary">Go to login
            page
          </button>
          <button v-if="fail" @click="goToPage('ForgotPassword')" style="cursor: pointer;" class="btn btn-primary">
            Send reset link again
          </button>
        </div>
        <div class="ibox text-center">
          <h4 class="custom-form-header">Enter new password</h4>
          <div class="ibox-body">
            <div class="form">
              <div class="row text-center">
                <div class="col-md-12 form-group">
                  <input v-model="password1" type="password" class="form-control" placeholder="Enter new password">
                </div>
                <div class="col-md-12 form-group">
                  <input v-model="password2" type="password" class="form-control" placeholder="Repeat new password">
                </div>
                <div class="col-md-12">
                  <button class="btn btn-primary custom-form-button" @click.prevent="resetPassword">Reset</button>
                </div>
                <div class="col-md-12">
                  <p v-if="errors.length !== 0" class="custom-form-error-message">{{$t('message.' + errors[0])}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ResetPassword",
    data() {
      return {
        password1: '',
        password2: '',
        errors: [],
        msg: null,
        success: false,
        fail: false,
      }
    },
    methods: {
      goToPage(page) {
        this.$router.push({name: page});
      },
      resetPassword() {
        let token = this.$route.params['token'];
        let self = this;

        this.validateForm();

        if (this.errors.length !== 0) {
          return;
        }

        this.update(this.apiPrefix, this.authApiUrl + '/reset-password/' + token, '', {
          password: this.password1
        })
          .then(() => {
            self.msg = 'resetPasswordSuccess';
            self.success = true;
          })
          .catch(() => {
            self.msg = 'tokenExpired';
            self.fail = true;
          })
      },
      validateForm() {
        this.errors = [];

        if (!this.validateFieldLength(8, 20, this.password1)) {
          this.errors.push('passwordMinLen');
        }

        if (!this.validateFieldsMatch(this.password1, this.password2)) {
          this.errors.push('passwordsMatch');
        }
      }
    }
  }
</script>

<style scoped>

</style>
